<template>

  <div class="py-4 container-fluid">
    <div class="row">

        <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
          <default-info-card
              v-if="Permissions.hasPermission(horse, [Permissions.PERMISSION_VACCINE])"
              icon="text-white fas fa-syringe"
              title="VACCINI"
              description="Tutte i vaccini del cavallo"
              value=""
              :routerLink="{ name: 'HorseVaccins', params: { id } }"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
          <default-info-card
              v-if="Permissions.hasPermission(horse, [Permissions.PERMISSION_THERAPY])"
              icon="text-white fas fa-notes-medical"
              title="TERAPIE"
              description="Tutte le terapie del cavallo"
              value=""
              :routerLink="{ name: 'HorseHealthProblems', params: { id } }"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
          <default-info-card
              v-if="Permissions.hasPermission(horse, [Permissions.PERMISSION_DIAGNOSIS])"
              icon="text-white fas fa-microscope"
              title="DIAGNOSI"
              description="Lista delle diagnosi"
              value=""
              :routerLink="{ name: 'HorseExams', params: { id } }"
          />
        </div>
        <div class="col-xl-3 col-sm-6 mb-xl-0">
          <default-info-card
              v-if="Permissions.hasPermission(horse, [Permissions.PERMISSION_OTHER_TREATMENT])"
              icon="text-white fas fa-hand-holding-medical"
              title="TRATTAMENTI PERIODICI"
              description="Lista dei trattamenti"
              value=""
              :routerLink="{ name: 'HorseTreatments', params: { id } }"
          />
        </div>

    </div>
  </div>

</template>


<script>

import DefaultInfoCard from "@/examples/Cards/DefaultInfoCard.vue";
import { horsesService } from '@/services/HorsesService';
import Permissions from '../../services/PermissionService';

export default {
  name: "HorseHealth",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      horse: {},
      Permissions
    };
  },
  async created() {
    this.$store.dispatch('updateBreadcrumbs', [
      { title: 'Lista Cavalli', name: 'Horses' },
      { title: 'Cavallo', name: 'Horse', params: { id: this.id } }
    ]);

    this.horse = await horsesService.getHorseById(this.id);

  },
  components: {
    DefaultInfoCard
  },
  methods: {
  },
};
</script>
